import React, { useState } from "react";
import Modal from "react-modal";

export default function ConfirmModal({modalIsOpen, closeModal, newItem, context, props}) {

    const [askAddOn, setAskAddOn] = useState(true)

    const addOn = function (price) {
        const addItem = {
            name: "Add 6 Weeks",
            description: `${newItem.name} Add On`,
            quantity: 1,
            price: newItem.add_six_weeks,
            schedule_link: "https://calendly.com/iglf/initial-consultation"
        }
        context.actions.addToCart(addItem)
        setAskAddOn(false)
    }

    const handleClose = function () {
        setAskAddOn(true)
        closeModal()
    }

    const handleViewCart = function () {
        setAskAddOn(true)
        props.history.push("/checkout/")
    }

    return (
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            contentLabel="Item added to cart"
            className="modal"
            overlayClassName="overlay"
            appElement={document.getElementById("main")}
        >
            <div className="modal-container">
                <div className="modal-header">
                    <h2>Item Added To Cart!</h2>
                    <button className="button" onClick={handleClose}>
                        X
                    </button>
                </div>
            <div className="modal-contents">
                <div className="modal-item">
                    <div className="left">
                        <div>Your Training Session</div>
                        <div>Session Type</div>
                        <div>Duration</div>
                    </div>
                    <div className="right">
                        <div className="name">{newItem.name}</div>
                        <div className="description">{newItem.description}</div>
                        <div className="duration">6 Weeks{!askAddOn && (<span> + 6 Additional Weeks!</span>)}</div>
                    </div>
                </div>
            </div>
            <div className="add-on">
                {askAddOn ? (
                    <button className="button" title="Add on 6 weeks?" onClick={addOn}>Add on 6 weeks for ${newItem.add_six_weeks}</button>
                ):(
                    <div className="upgraded">Upgrade added!</div>
                )}
            </div>
            <div className="buttons">
                <button className="button" onClick={handleClose}>Close</button>
                <button className="button" onClick={handleViewCart}>View Cart</button>
            </div>
        </div>
        </Modal>
        );
}

// {newItem ? (
//                     <div className="map">
//                     {newItem.map((item, index) => {
//                         return (
//                             <div className="modal-item" key={index}>
//                                 <div className="left">
//                                     <button
//                                         className="button"
//                                     >
//                                         X
//                                     </button>
//                                     <div className="name">{item.name}</div>
//                                     <div className="description">{item.description}</div>
//                                 </div>
//                                 <div className="right">
//                                     <div className="quantity">{item.quantity}</div>
//                                     <div className="price">{item.price}</div>
//                                 </div>
//                             </div>
//                         );
//                     })}
//                 </div>
//             ) : (
//                 <div>No items have been added to your cart.</div>
//             )}